module.exports = __webpack_public_path__ + "static/media/close_grey.80e0a543.svg";